import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import FormControl from '@material-ui/core/FormControl'
import Checkbox from '@material-ui/core/Checkbox'
import { InputLabel, FormControlLabel } from '@material-ui/core'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import cn from 'classnames'
import isEqual from 'lodash/isEqual'
import messages from '../translate'

class JobBooleanInput extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: this.isCheckbox() ? false : null,
      evtTaskInputId: '',
      isUpdating: false,
    }
  }

  componentDidMount() {
    const { inputData } = this.props
    const value = inputData.value !== undefined ? inputData.value : null

    this.setState({
      value,
      evtTaskInputId: inputData.evtInputId,
    })
  }

  shouldComponentUpdate(nextProps) {
    const { inputInfo, inputData } = this.props
    const { inputInfo: nextInputInfo, inputData: nextInputData } = nextProps

    if (
      !isEqual(inputInfo, nextInputInfo) ||
      !isEqual(inputData, nextInputData)
    ) {
      const value =
        nextInputData.value !== undefined ? nextInputData.value : null

      this.setState({
        value,
        evtTaskInputId: nextInputData.evtInputId,
      })

      return false
    }

    return true
  }

  setResultId = ({ id }) => {
    this.setState({ evtTaskInputId: id })
  }

  onInputChange = (e, isCheckbox = false) => {
    const {
      inputInfo,
      inputData: { evtInputId },
      onJobTaskAutoSave,
    } = this.props
    const { value, evtTaskInputId } = this.state
    let currentValue = false

    if (!isCheckbox) {
      const { checked } = e.target.dataset

      if (!value && checked) {
        currentValue = true
      } else if ((value && checked) || value === currentValue) {
        currentValue = null
      }
    } else {
      this.setState(
        prevState => ({ value: !prevState.value }),
        () => {
          this.setState({
            isUpdating: true,
          })

          onJobTaskAutoSave(
            {
              evtInputId: evtInputId || evtTaskInputId,
              result: this.state.value,
              input: inputInfo.id,
              setResultId: this.setResultId,
            },
            () => {
              this.setState({
                isUpdating: false,
              })
            },
          )
        },
      )
    }

    if (value !== currentValue && !isCheckbox) {
      this.setState({
        isUpdating: true,
      })

      onJobTaskAutoSave(
        {
          evtInputId: evtInputId || evtTaskInputId,
          result: currentValue,
          input: inputInfo.id,
          setResultId: this.setResultId,
        },
        () => {
          this.setState({
            isUpdating: false,
          })
        },
      )

      this.setState({ value: currentValue })
    }
  }

  isCheckbox = () => {
    const {
      inputInfo: { parameters },
    } = this.props

    return Object.keys(parameters).length && parameters.display === 'checkbox'
  }

  render() {
    const {
      index,
      disabled,
      className,
      inputInfo: { title, required },
      intl: { formatMessage },
    } = this.props
    const { value, isUpdating } = this.state
    const inputId = `jobBoolean${index}`
    const isInputDisabled = isUpdating || disabled
    const labelClickHandler = !isInputDisabled ? this.onInputChange : null
    const drawAsterisk = required ? '*' : ''

    return (
      <FormControl fullWidth className={className}>
        {this.isCheckbox() ? (
          <FormControlLabel
            label={`${title} ${drawAsterisk}`}
            control={
              <Checkbox
                href={null}
                id={inputId}
                color="primary"
                checked={value}
                required={required}
                disabled={isInputDisabled}
                icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                checkedIcon={<CheckBoxIcon fontSize="large" />}
                onChange={e => this.onInputChange(e, true)}
              />
            }
          />
        ) : (
          <>
            <span className="job-field-label">
              {title} {drawAsterisk}
            </span>
            <div className="job-field-boolean-wrapper">
              <InputLabel
                htmlFor={inputId}
                className={cn('job-field-label job-field-boolean-label', {
                  checked: value === true,
                  disabled: isInputDisabled,
                })}
                onClick={labelClickHandler}>
                <div
                  className="job-field-input job-field-input-boolean"
                  data-checked="yes">
                  {formatMessage(messages.yes)}
                </div>
              </InputLabel>
              <InputLabel
                htmlFor={inputId}
                className={cn('job-field-label job-field-boolean-label', {
                  checked: value === false,
                  disabled: isInputDisabled,
                })}
                onClick={labelClickHandler}>
                <div className="job-field-input job-field-input-boolean">
                  {formatMessage(messages.no)}
                </div>
              </InputLabel>
            </div>
            <Checkbox
              href=""
              id={inputId}
              checked={value}
              className="job-field-input-checkbox"
              disabled={isInputDisabled}
            />
          </>
        )}
      </FormControl>
    )
  }
}

export default injectIntl(JobBooleanInput)
